import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../base/dtos/base-stats.dto';

/**
 * Users stats DTO
 */
@CaslSubject(AppSubjectEnum.USER)
export class UsersStatsDto extends BaseStatsDto {
	active!: number;
	inactive!: number;
}
